import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Shell } from './shell.service';
import { AuthenticationGuard } from '@app/auth';

import { DashboardComponent } from '@app/dashboard/dashboard.component';
import { ClientComponent } from '@app/client/client.component';
import { ClientEditComponent } from '@app/client_edit/client_edit.component';
// import { StandortComponent } from '@app/standort/standort.component';
import { ReportsComponent } from '@app/reports/reports.component';
import { AboutComponent } from '@app/about/about.component';
import { SettingsComponent } from '@app/settings/settings.component';
import { StammdatenComponent } from '@app/stammdaten/stammdaten.component';
import { DatenschutzComponent } from '@app/datenschutz/datenschutz.component';
import { ImpressumComponent } from '@app/impressum/impressum.component';
import { HelpComponent } from '@app/help/help.component';
import { SupportComponent } from '@app/support/support.component';

import { extract } from '@app/i18n';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'dashboard',
      canActivate: [AuthenticationGuard],
      component: DashboardComponent,
      data: { title: extract('Dashboard') },
    },

    {
      path: 'clients',
      canActivate: [AuthenticationGuard],
      component: ClientComponent,
      data: { title: 'Clients' },
    },
    {
      path: 'client-edit/:id',
      canActivate: [AuthenticationGuard],
      component: ClientEditComponent,
      data: { title: 'Edit Client' },
    },

    // Lazy-loaded routes
    {
      path: 'mitarbeiter',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../mitarbeiter/mitarbeiter.module').then((m) => m.MitarbeiterModule),
      data: { title: 'Mitarbeiter' },
    },
    {
      path: 'techniker',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../techniker/techniker.module').then((m) => m.TechnikerModule),
      data: { title: 'Techniker' },
    },
    {
      path: 'mitarbeiter-edit',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../mitarbeiter_edit/mitarbeiter_edit.module').then((m) => m.MitarbeiterEditModule),
      data: { title: 'Mitarbeiter Bearbeiten' },
    },
    {
      path: 'standorte',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../standorte/standorte.module').then((m) => m.StandorteModule),
      data: { title: 'Standorte' },
    },
    {
      path: 'hausverwaltungen',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../hausverwaltung/hausverwaltung.module').then((m) => m.HausverwaltungModule),
      data: { title: 'Hausverwaltungen' },
    },
    {
      path: 'projektaufgaben',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../projektaufgabe/projektaufgabe.module').then((m) => m.ProjektaufgabeModule),
      data: { title: 'Projektaufgaben' },
    },
    {
      path: 'kontrolltermine',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../kontrolltermine/kontrolltermine.module').then((m) => m.KontrolltermineModule),
      data: { title: 'Kontrolltermine' },
    },
    {
      path: 'standort-edit',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../standort_edit/standort_edit.module').then((m) => m.StandortEditModule),
      data: { title: 'Standort Bearbeiten' },
    },
    {
      path: 'kontakt-edit',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../kontakt_edit/kontakt_edit.module').then((m) => m.KontaktEditModule),
      data: { title: 'Kontakt Bearbeiten' },
    },
    {
      path: 'berechtigungen',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../berechtigungen/berechtigungen.module').then((m) => m.BerechtigungenModule),
      data: { title: 'Berechtigungen' },
    },
    {
      path: 'benutzer',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../benutzer/benutzer.module').then((m) => m.BenutzerModule),
      data: { title: 'Benutzer' },
    },
    {
      path: 'indikatoren',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../indikatoren/indikatoren.module').then((m) => m.IndikatorenModule),
      data: { title: 'Indikatoren' },
    },
    {
      path: 'indikator-edit',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../indikator-edit/indikator-edit.module').then((m) => m.IndikatorEditModule),
      data: { title: 'Indikator Bearbeiten' },
    },

    {
      path: 'reports',
      canActivate: [AuthenticationGuard],
      component: ReportsComponent,
      data: { title: 'Reports' },
    },
    { path: 'about', canActivate: [AuthenticationGuard], component: AboutComponent, data: { title: extract('About') } },
    {
      path: 'settings',
      canActivate: [AuthenticationGuard],
      component: SettingsComponent,
      data: { title: extract('Settings') },
    },
    {
      path: 'system-settings',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../system-settings/system-settings.module').then(m => m.SystemSettingsModule),
      data: { title: 'Systemeinstellungen' },
    },
    {
      path: 'stammdaten',
      canActivate: [AuthenticationGuard],
      component: StammdatenComponent,
      data: { title: extract('Stammdaten') },
    },
    {
      path: 'datenschutz',
      canActivate: [],
      component: DatenschutzComponent,
      data: { title: extract('Datenschutz') },
    },
    {
      path: 'impressum',
      canActivate: [],
      component: ImpressumComponent,
      data: { title: extract('Impressum') },
    },
    { path: 'help', canActivate: [AuthenticationGuard], component: HelpComponent, data: { title: extract('Help') } },
    {
      path: 'support',
      canActivate: [AuthenticationGuard],
      component: SupportComponent,
      data: { title: extract('Support') },
    },
    {
      path: 'projects',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../projects/projects.module').then((m) => m.ProjectsModule),
      data: { title: 'Projekte' },
    },
    {
      path: 'projektaufgabe-edit',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../projektaufgabe-edit/projektaufgabe-edit.module').then((m) => m.ProjektaufgabeEditModule),
      data: { title: 'Projektaufgabe Bearbeiten' },
    },
    {
      path: 'plan',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../plan/plan.module').then((m) => m.PlanModule),
      data: { title: 'Pläne' },
    },
    {
      path: 'project-edit',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../project_edit/project_edit.module').then((m) => m.ProjectEditModule),
      data: { title: 'Projekt Bearbeiten' },
    },
    {
      path: 'project-detail',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../project_detail/project_detail.module').then((m) => m.ProjectDetailModule),
      data: { title: 'Projekt Details' },
    },
    
    // New routes for updated models
    {
      path: 'kontroll-indikator',
      canActivate: [AuthenticationGuard],
      loadChildren: () => import('../kontroll-indikator/kontroll-indikator.module').then((m) => m.KontrollIndikatorModule),
      data: { title: 'Kontroll-Indikatoren' },
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class ShellRoutingModule {}